module.exports = __webpack_public_path__ + "img/tr_waterbeng.9179f71e.png";